// Angular imports
import { Injectable, EventEmitter } from '@angular/core';

// Import base modal
import { BaseModalComponent } from '../modal/base-modal';

// Type for modal options
export type ModalOptions = {
    modal: typeof BaseModalComponent,
    args?: any;
};

@Injectable()
export class ModalService {
    // Event emmiters for modal component to trigger open and close
    public _requestModalOpen = new EventEmitter<ModalOptions>();
    public _requestModalClose = new EventEmitter<void>();

    // Publically readonly
    public get isModalOpen(): boolean {
        return this._isModalOpen;
    }
    private _isModalOpen: boolean = false;

    constructor() { }

    public open(modal: typeof BaseModalComponent, args?: any): boolean {
        // Check if modal is open
        if (this._isModalOpen) return false;

        // Trigger open event for modal component
        this._requestModalOpen.emit({ modal: modal, args: args });

        // Set modal as open
        this._isModalOpen = true;
        return true;
    }

    public close(): boolean {
        // Check if modal is open
        if (!this._isModalOpen) return false;

        // Trigger close event for modal component
        this._requestModalClose.emit();

        // Set modal as closed
        this._isModalOpen = false;
        return true;
    }
}
